__turbopack_context__.v({
  "infoBlock": "styles-module__fCes0a__infoBlock",
});
